// import React, { useState, useEffect, useContext } from 'react';
// import { useNavigate, Link, useLocation } from 'react-router-dom';
// import {
//   Box,
//   Card,
//   CardContent,
//   CardMedia,
//   Typography,
//   IconButton,
//   Button,
//   Grid,
//   Tooltip,
//   Menu,
//   MenuItem,
//   CircularProgress,
//     Delete as DeleteIcon,  // ← Added for black spinner 
// } from '@mui/material';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import RocketIcon from '@mui/icons-material/RocketLaunch';

// import {
//   FavoriteBorder,
//   Favorite,
//   PeopleAlt,
//   Share,
//   ThumbUpAltOutlined,
//   ThumbUpAlt,
//   Call,
//   LocationOn,
//   ChevronLeft,
//   ChevronRight,
//   MoreVert,
//    DeleteOutline,
// } from '@mui/icons-material';
// import axios from 'axios';
// import buildingImage from './../../../../Images/house.jpeg';
// import CustomSearchBar from './../../Lease Module/CustomSearch';
// import BottomNavbar from './../../Post Module/FormsBottomNavbar';
// import { AuthContext } from './../../../AuthContext/AuthContext';
// import { BASE_URL } from './../../../Api/ApiUrls';
// import { Visibility as VisibilityIcon } from '@mui/icons-material';
// import CopyFailureAlert from '../../Alertpage/CopyAlert/CopyFailureAlert';
// import CopySuccessAlert from '../../Alertpage/CopyAlert/CopySuccessAlert';
// import ShareCopySuccessAlert from '../../Alertpage/ShareAlert/ShareCopySuccessAlert';
// import ShareCopyFailureAlert from '../../Alertpage/ShareAlert/ShareCopyFailureAlert';
// import DeleteFailureAlert from '../../Alertpage/DeleteAlert/DeleteFailureAlert';
// import DeleteSuccessAlert from '../../Alertpage/DeleteAlert/DeleteSuccessAlert';
// import DeleteConfirmAlert from '../../Alertpage/DeleteAlert/DeleteConfirmAlert';
// import BoostFailureAlert from '../../Alertpage/CopyAlert/BoostFailureAlert';
// import BoostSuccessAlert from '../../Alertpage/CopyAlert/BoostAlert';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CancelIcon from '@mui/icons-material/Cancel';
// import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
// import Chip from '@mui/material/Chip';
// import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
// import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
// const API_BASE_URL = 'https://landnest.net:7000/api';

// const BuyPropertyCard = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { userId, logout } = useContext(AuthContext);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [error, setError] = useState(null);
//   // const passedType = locationn.state?.type?.toLowerCase();
//   const [menuPropertyId, setMenuPropertyId] = useState(null);
//   const [saved, setSaved] = useState(() => {
//     const stored = localStorage.getItem('savedBuy');
//     return stored ? JSON.parse(stored) : [];
//   });
//   const [likedCards, setLikedCards] = useState({});
//   const [properties, setProperties] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentImageIndex, setCurrentImageIndex] = useState({});
//   const [showNoResults, setShowNoResults] = useState(false);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [showFailure, setShowFailure] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
//   const [showShareSuccess, setShowShareSuccess] = useState(false);
//   const [showShareFailure, setShowShareFailure] = useState(false);
//   const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
//   const [showDeleteFailure, setShowDeleteFailure] = useState(false);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [menuPropertyIdToDelete, setMenuPropertyIdToDelete] = useState(null);

// // Add these new state variables for boost functionality
//   const [showBoostSuccess, setShowBoostSuccess] = useState(false);
//   const [showBoostFailure, setShowBoostFailure] = useState(false);
//   const [boostLoading, setBoostLoading] = useState(false);
  
//   // Tab state - get from URL path
//   const [currentTab, setCurrentTab] = useState(() => {
//     const path = location.pathname;
//     if (path.includes('/user-buy-simplified')) {
//       return 1;
//     }
//     return 0;
//   });
//   const [selectedProperties, setSelectedProperties] = useState([]);

//   const handleTabChange = (newValue) => {
//     setCurrentTab(newValue);
//     // Navigate to appropriate path
//     if (newValue === 0) {
//       navigate('/user-buy');
//     } else {
//       navigate('/user-buy-simplified');
//     }
//   };

//   const handleCheckboxChange = (propertyId) => {
//     setSelectedProperties(prev => {
//       if (prev.includes(propertyId)) {
//         return prev.filter(id => id !== propertyId);
//       } else {
//         return [...prev, propertyId];
//       }
//     });
//   };

//   const handleCallClick = async (e, property) => {
//     e.stopPropagation();

//     try {
//       if (property.mobile_no) {
//         await navigator.clipboard.writeText(property.mobile_no);

//         setAlertMessage(`Copied: ${property.mobile_no}`);
//         setShowSuccess(true);
//         setShowFailure(false);
//       } else {
//         setAlertMessage("Mobile number not available");
//         setShowFailure(true);
//         setShowSuccess(false);
//       }
//     } catch (error) {
//       setAlertMessage("Failed to copy mobile number");
//       setShowFailure(true);
//       setShowSuccess(false);
//     }
//   };
// //  const handleShare = async (event, property) => {
// //   event.stopPropagation();

// //   const shareUrl = `${window.location.origin}/buy-description/${property.id}`;

// //   if (navigator.share) {
// //     try {
// //       await navigator.share({
// //         title: property.title || "Check this property",
// //         text: "Check out this property",
// //         url: shareUrl,
// //       });
// //     } catch (error) {
// //       console.log("Share cancelled");
// //     }
// //   } else {
// //     // Fallback: copy link
// //     await navigator.clipboard.writeText(shareUrl);
// //     alert("Link copied to clipboard");
// //   }
// // };
//   const handleShare = async (event, property) => {
//     event.stopPropagation();

//     const propertyUrl = `${window.location.origin}/buy-description/${property.id}`;

//     try {
//       await navigator.clipboard.writeText(propertyUrl);

//       setAlertMessage("Property link copied successfully!");
//       setShowShareSuccess(true);
//       setShowShareFailure(false);
//     } catch (error) {
//       setAlertMessage("Failed to copy property link");
//       setShowShareFailure(true);
//       setShowShareSuccess(false);
//     }
//   };


//   const handleMenuOpen = (event, propertyId) => {
//     event.stopPropagation();
//     setAnchorEl(event.currentTarget);
//     setMenuPropertyId(propertyId);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setMenuPropertyId(null);
//   };

//   const handleEdit = () => {
//     navigate(`/user-edit-buy/${menuPropertyId}`);
//   };

//   const handleDelete = async () => {
//     if (!menuPropertyIdToDelete) return;

//     try {
//       const response = await fetch(`${BASE_URL}/property/${menuPropertyIdToDelete}/`, {
//         method: 'DELETE',
//       });

//       if (response.ok) {
//       // Remove from state immediately
//         setProperties(prev => prev.filter(p => p.id !== menuPropertyIdToDelete));
//         setAlertMessage(`Property ID ${menuPropertyIdToDelete} deleted successfully.`);
//         setShowDeleteSuccess(true);
//       } else {
//         const errorData = await response.json();
//         setAlertMessage(
//           `Failed to delete property ID ${menuPropertyIdToDelete}. Reason: ${errorData.detail || "Unknown error"}`
//         );
//         setShowDeleteFailure(true);
//       }
//     } catch (error) {
//       console.error("Error deleting property:", error);
//       setAlertMessage("An error occurred while trying to delete the property.");
//       setShowDeleteFailure(true);
//     } finally {
//       setMenuPropertyIdToDelete(null);
//       handleMenuClose();
//     }
//   };

// //   const handleDeleteProperty = async (propertyId) => {
// //   try {
// //     const confirmDelete = window.confirm(`Are you sure you want to delete property ID ${propertyId}?`);
    
// //     if (!confirmDelete) {
// //       return;
// //     }

// //     const response = await fetch(`${BASE_URL}/property/${propertyId}/`, {
// //       method: 'DELETE',
// //     });

// //     if (response.ok) {
// //       setAlertMessage(`Property ID ${propertyId} deleted successfully.`);
// //          setShowDeleteSuccess(true);
// //       setShowDeleteFailure(false);
// //       // FIX: Remove from state immediately
// //       setProperties(prev => prev.filter(p => p.id != propertyId));
// //     } else {
// //       const errorData = await response.json();
// //       setAlertMessage(`Failed to delete property ID ${propertyId}. Reason: ${errorData.detail || 'Unknown error'}`);
// //          setShowDeleteFailure(true);
// //       setShowDeleteSuccess(false);
// //     }
// //   } catch (error) {
// //     console.error('Error deleting property:', error);
// //     setAlertMessage('An error occurred while trying to delete the property.');
// //         setShowDeleteFailure(true);
// //     setShowDeleteSuccess(false);
// //   }
// // };

//   const isBudgetInRange = (propertyPrice, minBudget, maxBudget) => {
//     if (!propertyPrice) return false;

//     if (minBudget && maxBudget) {
//       const range = (maxBudget - minBudget) * 0.10;
//       const extendedMin = Math.max(0, minBudget - range);
//       const extendedMax = maxBudget + range;
      
//       return propertyPrice >= extendedMin && propertyPrice <= extendedMax;
//     }
    
//   // If only min budget is provided
//     if (minBudget && !maxBudget) {
//     const extendedMin = minBudget * 0.90; // 10% below min budget
//       return propertyPrice >= extendedMin;
//     }
    
//   // If only max budget is provided
//     if (!minBudget && maxBudget) {
//       const extendedMax = maxBudget * 1.10;
//       return propertyPrice <= extendedMax;
//     }
    
//     return false;
//   };

//   const getPropertyImages = async (propertyId) => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/properties/${propertyId}/images`);
//       const data = await response.json();

//       if (!response.ok) throw new Error(data.error || 'Failed to fetch images');
//       return data;
//     } catch (error) {
//       console.error('API Error fetching images:', error);
//       return { success: false, images: [] };
//     }
//   };


//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       setShowNoResults(false);
      
//     // Fetch categories first
//       const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
//       setCategories(categoriesResponse.data);

//     // Fetch user properties from new API endpoint with type=sell
//       const propertiesResponse = await axios.get(`${API_BASE_URL}/api/properties/user/${userId}?type=sell`);

//     // Fetch user subscriptions
//       const plansResponse = await axios.get(`${BASE_URL}/Get-all-plan/${userId}/`);
//       const subscriptions = plansResponse.data || [];

//     // Fetch cart items
//       const cartResponse = await axios.get(`${BASE_URL}/user-cart/`);
//       const cartItems = cartResponse.data;

//     // Fetch buyer enquiries
//       const enquiriesResponse = await axios.get(`${BASE_URL}/Enquiry/`);
//       const enquiries = enquiriesResponse.data;

//     // Fetch activities to get view counts
//       const activitiesResponse = await axios.get(`${BASE_URL}/activities/`);
//       const activities = activitiesResponse.data;

//     // Get properties from API response (already filtered by user_id and type=sell)
//       const userProperties = propertiesResponse.data.data || propertiesResponse.data;
      
//     // Sort by created_at (newest first)
//       const sortedProperties = userProperties.sort((a, b) => 
//         new Date(b.created_at) - new Date(a.created_at)
//       );

//     // Fetch images for each property using the image API
//       const parsed = await Promise.all(sortedProperties.map(async (item) => {
//         const wishlistUsers = cartItems
//           .filter(
//             cartItem =>
//               cartItem.property_id === item.property_id &&
//               cartItem.user_id !== userId
//           )
//           .map(cartItem => cartItem.user_id);

//         const uniqueWishlistUsers = [...new Set(wishlistUsers)];
//         const wishlistCount = uniqueWishlistUsers.length;

//       // Determine which subscription applies to this property
//         const postedBy = item.posted_by?.replace(/"/g, '') || '';
//         const requiredUserType = mapPostedByToUserType(postedBy);

//       // Find matching active subscription
//         const matchedSub = subscriptions.find(
//           sub => sub.status === true && sub.user_type === requiredUserType
//         );

//         const daysLeftForProperty = matchedSub?.expired_date
//           ? calculateDaysLeft(matchedSub.expired_date)
//           : null;

//         const viewCount = [
//           ...new Set(
//             activities
//               .filter(
//                 activity =>
//                   activity.property_id === item.property_id &&
//                   activity.activity_type === "Description" &&
//                   activity.user_id !== userId
//               )
//               .map(activity => activity.user_id)
//           )
//         ].length;

//       // Matching buyers calculation with 10% range logic
//         const matchingBuyersCount = enquiries.filter(enquiry => {
//           const propertyCategory = categoriesResponse.data.find(
//             cat => cat.category_id == item.category_id_id
//           )?.category;

//           const typeMatch = enquiry.property_type && propertyCategory &&
//             enquiry.property_type.toLowerCase() === propertyCategory.toLowerCase();

//           const budgetMatch = isBudgetInRange(item.price, enquiry.min_budget, enquiry.max_budget);

//           const locationMatch = () => {
//             if (!enquiry.lat || !enquiry.long || !item.lat || !item.long) return false;

//             const propLat = parseFloat(item.lat);
//             const propLong = parseFloat(item.long);
//             const enqLat = parseFloat(enquiry.lat);
//             const enqLong = parseFloat(enquiry.long);

//             const R = 6371;
//             const dLat = (enqLat - propLat) * Math.PI / 180;
//             const dLon = (enqLong - propLong) * Math.PI / 180;
//             const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//               Math.cos(propLat * Math.PI / 180) * Math.cos(enqLat * Math.PI / 180) *
//               Math.sin(dLon / 2) * Math.sin(dLon / 2);
//             const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//             const distance = R * c;

//             return distance <= 10;
//           };

//           return typeMatch && budgetMatch && locationMatch();
//         }).length;

//         const parseCoord = (coord) => {
//           if (!coord) return null;
//           const cleaned = String(coord).replace(/"/g, '').replace(':', '.');
//           return parseFloat(cleaned);
//         };

//         const matchedCategory = categoriesResponse.data.find(
//           cat => cat.category_id == item.category_id_id
//         );

//         const categoryName = matchedCategory ? matchedCategory.category : 'Property';

//       // Fetch images using the dedicated image API
//       let images = [buildingImage]; // Default image
//         try {
//           const imageResponse = await getPropertyImages(item.property_id);
          
//           if (imageResponse.success && imageResponse.images && imageResponse.images.length > 0) {
//           // Map the images to full URLs
//             images = imageResponse.images.map(img => {
//             // If img already has full URL, use it, otherwise prepend BASE_URL
//               if (img.startsWith('http')) {
//                 return img;
//               } else if (img.startsWith('/')) {
//                 return `${BASE_URL}${img}`;
//               } else {
//                 return `${BASE_URL}/${img}`;
//               }
//             });
//           }
//         } catch (imgError) {
//           console.error(`Error fetching images for property ${item.property_id}:`, imgError);
//         // Keep default image if fetch fails
//         }

//         return {
//           id: item.property_id,
//           title: categoryName,
//           location: item.location || 'Not specified',
//           price: item.price,
//           formattedPrice: `₹${Math.round(item.price).toLocaleString('en-IN')}`,
//           date: item.created_at?.split('T')[0],
//           facing: item.facing?.replace(/"/g, '') || 'N/A',
//           area: item.site_area
//             ? `${item.site_area} ${
//                 ["ft", "m", "cm", "in", "Sq.Yd"].includes(item.units)
//                   ? `Sq ${item.units}`
//                   : item.units || "Sq ft"
//               }`
//             : 'N/A',
//           max_acres: item.max_acres ? `${item.max_acres} ${item.units || "acres"}` : 'N/A',
//           dimensions: item.roadwidth ? `${Math.round(item.roadwidth)} ft road` : 'N/A',
//           posted_by: item.posted_by?.replace(/"/g, '') || 'Agent',
//           lat: parseCoord(item.lat),
//           long: parseCoord(item.long),
//           length: item.length,
//           width: item.width,
//           mobile_no: item.mobile_no,
//           property_name: item.property_name,
//         images: images, // Use images from the dedicated API
//           propertyData: item,
//           wishlistCount: wishlistCount,
//           viewCount: viewCount,
//           matchingBuyersCount: matchingBuyersCount,
//           daysLeft: daysLeftForProperty,
//           admin_status: item.Admin_status || '',
//         };
//       }));

//       setProperties(parsed);
      
//     // Initialize current image index for each property
//       const initialIndexes = {};
//       parsed.forEach(property => {
//         initialIndexes[property.id] = 0;
//       });
//       setCurrentImageIndex(initialIndexes);
      
//       if (parsed.length === 0) {
//         setShowNoResults(true);
//       }
//     } catch (error) {
//       console.error('Error fetching data:', {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status,
//       });
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [userId]);

//   // Update currentTab when location changes
//   useEffect(() => {
//     const path = location.pathname;
//     if (path.includes('/user-buy-simplified')) {
//       setCurrentTab(1);
//     } else if (path.includes('/user-buy')) {
//       setCurrentTab(0);
//     }
//   }, [location.pathname]);

//   const handleWishlistClick = (propertyId, e) => {
//     e.stopPropagation();
//     console.log("Navigating to wishlist details for property:", propertyId);
//     navigate(`/wishlist-users/${propertyId}`); // or whatever route you want
//   };

//   const handleMatchingBuyersClick = (propertyId, e) => {
//     e.stopPropagation();
//     console.log("Navigating to matching buyers for property:", propertyId);
//     navigate(`/matching-buyers/${propertyId}`);
//   };

//   const handleNextImage = (propertyId, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(prev => {
//       const currentIndex = prev[propertyId];
//       const property = properties.find(p => p.id == propertyId);
//       const nextIndex = (currentIndex + 1) % property.images.length;
//       return {
//         ...prev,
//         [propertyId]: nextIndex
//       };
//     });
//   };

//   const handlePrevImage = (propertyId, e) => {
//     e.stopPropagation();
//     setCurrentImageIndex(prev => {
//       const currentIndex = prev[propertyId];
//       const property = properties.find(p => p.id == propertyId);
//       const prevIndex = (currentIndex - 1 + property.images.length) % property.images.length;
//       return {
//         ...prev,
//         [propertyId]: prevIndex
//       };
//     });
//   };

//   const openGoogleMapsWithDirections = (destLat, destLng) => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const currentLat = position.coords.latitude;
//           const currentLng = position.coords.longitude;

//           const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${destLat},${destLng}&travelmode=driving`;

//           window.open(googleMapsUrl, '_blank');
//         },
//         (error) => {
//           console.error("Error getting location:", error);
//           alert("Could not get your location. Please allow location access.");
//         }
//       );
//     } else {
//       alert("Geolocation is not supported by your browser.");
//     }
//   };



//   const truncateText = (text, maxLength) => {
//     if (!text) return '';
//     return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
//   };

//   const filteredProperties = properties.filter((property) =>
//     property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     property.location.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   const calculateDaysLeft = (expiredDate) => {
//     if (!expiredDate) return 0;

//     const now = new Date();
//     const expiry = new Date(expiredDate);
//     const diffTime = expiry - now;
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

//     return diffDays > 0 ? diffDays : 0;
//   };

//   const mapPostedByToUserType = (postedBy) => {
//     if (!postedBy) return null;

//     const value = postedBy.toLowerCase();

//     if (value === "owner" || value === "builder") {
//       return "Individual Owner/Builder";
//     }

//     if (value === "agent") {
//       return "Agent";
//     }

//     return null;
//   };


//   const handleBoostProperty = async () => {
//     setBoostLoading(true);
//     try {
//       const response = await axios.post(`${BASE_URL}/boost-property/`, { user_id: userId });
//       console.log('Boost success:', response.data);
//       setAlertMessage('Property boosted successfully!');
//       setShowBoostSuccess(true);
//     } catch (error) {
//       console.error('Boost failed:', error);
//       setAlertMessage('Failed to boost property. Please try again.');
//       setShowBoostFailure(true);
//     } finally {
//       setBoostLoading(false);
//     }
//   };

//   const handleExtensionClick = () => {
//     navigate('/user-subscription');
//   };

//   // ==================== BLACK SPINNER WHILE LOADING ====================
//   if (loading) {
//     return (
//       <Box
//         sx={{
//           backgroundColor: 'rgb(184, 174, 162)',
//           minHeight: '100vh',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           gap: 3,
//         }}
//       >
//         <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
//         <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
//           Loading properties...
//         </Typography>
//       </Box>
//     );
//   }

//   if (error) return <Box>Error: {error}</Box>;

//   const handleViewListClick = (propertyId, e) => {
//     e.stopPropagation();
//     console.log("Navigating to view list for property:", propertyId);
//     navigate(`/viewlistpage/${propertyId}`);
//   };

//   // Render property card with all buttons (Tab 1)
//  const renderFullPropertyCard = (property) => (
//   <Card
//     key={property.id}
//     sx={{
//       mb: 1,
//       mx: 1,
//       borderRadius: 3,
//       boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
//       overflow: 'hidden',
//       transition: 'transform 0.2s ease-in-out',
//       '&:hover': { transform: 'scale(1.01)', boxShadow: '0 4px 16px rgba(0,0,0,0.12)' },
//     }}
//     onClick={(e) => {
//       const isInteractiveElement =
//         e.target.closest('button') ||
//         e.target.closest('svg') ||
//         e.target.closest('.MuiMenu-root') ||
//         e.target.closest('.MuiMenuItem-root');
//       if (!isInteractiveElement) {
//         navigate('/buy-description', { state: { propertyId: property.id, property: property.propertyData } });
//       }
//     }}
//   >
//     {/* ================= TOP: image (left) + details (right) ================= */}
//     <Box sx={{ display: 'flex', gap: 1, p: 1, pb: 1 }}>
//       {/* ---- Image column ---- */}
//       <Box
//         sx={{
//           position: 'relative',
//           width: '50%',
//           flexShrink: 0,
//           borderRadius: 2.5,
//           overflow: 'hidden',
//         }}
//       >
//         <CardMedia
//           component="img"
//           image={property.images[currentImageIndex[property.id]]}
//           alt="Property"
//           sx={{ width: '100%', height: '100%', minHeight: 170, objectFit: 'cover' }}
//         />

//         {/* FEATURED badge */}
//         <Box
//           sx={{
//             position: 'absolute',
//             top: 8,
//             left: 8,
//             backgroundColor: '#D9A441',
//             color: '#FFFFFF',
//             fontSize: '9px',
//             fontWeight: 700,
//             letterSpacing: '0.4px',
//             px: 1,
//             py: 0.4,
//             borderRadius: '6px',
//           }}
//         >
//           FEATURED
//         </Box>

//         {/* Share / More icons */}
//         <Box sx={{ position: 'absolute', top: 8, right: 8, display: 'flex', gap: 0.7 }}>
//           <IconButton
//             size="small"
//             sx={{ bgcolor: 'rgba(255,255,255,0.9)', width: 26, height: 26, '&:hover': { bgcolor: '#fff' } }}
//             onClick={(e) => handleShare(e, property)}
//           >
//             <Share sx={{ fontSize: 14 }} />
//           </IconButton>
//           <IconButton
//             size="small"
//             sx={{ bgcolor: 'rgba(255,255,255,0.9)', width: 26, height: 26, '&:hover': { bgcolor: '#fff' } }}
//             onClick={(e) => handleMenuOpen(e, property.id)}
//           >
//             <MoreVert sx={{ fontSize: 14 }} />
//           </IconButton>
//         </Box>

//         {/* Photo count */}
//         {property.images.length > 0 && (
//           <Box
//             sx={{
//               position: 'absolute',
//               bottom: 8,
//               left: 8,
//               backgroundColor: 'rgba(0,0,0,0.6)',
//               color: '#FFFFFF',
//               fontSize: '9px',
//               fontWeight: 500,
//               px: 1,
//               py: 0.4,
//               borderRadius: '6px',
//               display: 'flex',
//               alignItems: 'center',
//               gap: 0.4,
//             }}
//           >
//             <CollectionsOutlinedIcon sx={{ fontSize: 12 }} />
//             {property.images.length} Photos
//           </Box>
//         )}

//         {/* Carousel arrows */}
//         {property.images.length > 1 && (
//           <>
//             <IconButton
//               sx={{
//                 position: 'absolute', top: '50%', left: 4, opacity: 0, transform: 'translateY(-50%)',
//                 backgroundColor: 'rgba(255,255,255,0.3)', backdropFilter: 'blur(2px)',
//                 '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.5)' },
//               }}
//               onClick={(e) => handlePrevImage(property.id, e)}
//             >
//               <ChevronLeft fontSize="small" />
//             </IconButton>
//             <IconButton
//               sx={{
//                 position: 'absolute', top: '50%', right: 4, opacity: 0, transform: 'translateY(-50%)',
//                 backgroundColor: 'rgba(255,255,255,0.3)', backdropFilter: 'blur(2px)',
//                 '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.5)' },
//               }}
//               onClick={(e) => handleNextImage(property.id, e)}
//             >
//               <ChevronRight fontSize="small" />
//             </IconButton>
//           </>
//         )}

//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleMenuClose}
//           anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//           transformOrigin={{ vertical: 'top', horizontal: 'right' }}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <MenuItem onClick={(e) => { e.stopPropagation(); handleEdit(); }}>Edit</MenuItem>
//           <MenuItem
//             onClick={(e) => {
//               e.stopPropagation();
//               setMenuPropertyIdToDelete(property.id);
//               setShowDeleteConfirm(true);
//             }}
//           >
//             Delete
//           </MenuItem>
//         </Menu>
//       </Box>

//       {/* ---- Details column ---- */}
//       <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
//         <Box>
//           <Typography
//             sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#1a1a1a', lineHeight: 1.25, mb: 0.3 }}
//             noWrap
//           >
//             {property.title}-{truncateText(property.property_name, 17)}
//           </Typography>
//           <Typography sx={{ fontSize: '1.05rem', fontWeight: 700, color: '#D9A441' }} noWrap>
//             ₹{Number(String(property.price).replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
//           </Typography>
//         </Box>

//         <Box sx={{ mt: 1 }}>
//           <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.6, mb: 0.6 }}>
//             <LocationOn sx={{ fontSize: 15, color: '#8a8a8a', mt: '1px', flexShrink: 0 }} />
//             <Typography sx={{ fontSize: '0.72rem', color: '#666', lineHeight: 1.3 }}>
//               {property.location}
//             </Typography>
//           </Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
//             <CalendarTodayOutlinedIcon sx={{ fontSize: 13, color: '#8a8a8a', flexShrink: 0 }} />
//             <Typography sx={{ fontSize: '0.72rem', color: '#666' }}>
//               {new Date(property.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
//             </Typography>
//           </Box>
//         </Box>

//         <Box sx={{ display: 'flex', gap: 1, mt: 1.2, flexWrap: 'wrap' }}>
//           {(() => {
//             const status = !property.admin_status || property.admin_status === '' ? 'pending' : property.admin_status.toLowerCase();
//             const getStyles = () => {
//               switch (status) {
//                 case 'approved': return { color: '#4caf50', icon: <CheckCircleIcon sx={{ fontSize: 15 }} />, label: 'Approved' };
//                 case 'rejected': return { color: '#f44336', icon: <CancelIcon sx={{ fontSize: 15 }} />, label: 'Rejected' };
//                 default: return { color: '#ff9800', icon: <HourglassEmptyIcon sx={{ fontSize: 15 }} />, label: 'Pending' };
//               }
//             };
//             const { color, icon, label } = getStyles();
//             return (
//               <Chip
//                 icon={icon}
//                 label={label}
//                 variant="outlined"
//                 sx={{
//                   height: 26,
//                   borderColor: color,
//                   borderRadius: '6px',
//                   color,
//                   fontWeight: 600,
//                   fontSize: '0.68rem',
//                   '& .MuiChip-icon': { color },
//                 }}
//               />
//             );
//           })()}

//           <Button
//             size="small"
//             variant="outlined"
//             startIcon={<Call sx={{ fontSize: 14 }} />}
//             onClick={(e) => handleCallClick(e, property)}
//             sx={{
//               textTransform: 'none',
//               borderRadius: '6px',
//               borderColor: '#D9A441',
//               color: '#D9A441',
//               fontSize: '0.68rem',
//               fontWeight: 600,
//               px: 1.4,
//               py: 0.2,
//               '&:hover': { borderColor: '#D9A441', backgroundColor: 'rgba(217,164,65,0.06)' },
//             }}
//           >
//             Call
//           </Button>
//         </Box>
//       </Box>
//     </Box>

//     {/* ================= FACING / AREA / POSTED BY ================= */}
//   <Box sx={{ 
//   display: 'flex', 
//   px: 1, 
//   py: 1.2, 
//   border: '1px solid #E8E5E0',
//   borderRadius: '8px',
//   backgroundColor: '#fff',
//   overflow: 'hidden'
// }}>
//   {[
//     { label: 'Facing', value: property.facing },
//     { label: 'Area', value: property.area || property.max_acres },
//     { label: 'Posted By', value: property.posted_by },
//   ].map((item, index) => (
//     <Box 
//       key={index} 
//       sx={{ 
//         flex: 1, 
//         textAlign: 'center',
//         position: 'relative',
//         ...(index < 2 && {
//           '&::after': {
//             content: '""',
//             position: 'absolute',
//             right: 0,
//             top: '15%',
//             height: '70%',
//             width: '1px',
//             backgroundColor: '#E8E5E0'
//           }
//         })
//       }}
//     >
//       <Typography sx={{ fontSize: '0.68rem', color: '#999', mb: 0.3 }}>
//         {item.label}
//       </Typography>
//       <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: '#222' }} noWrap>
//         {item.value}
//       </Typography>
//     </Box>
//   ))}
// </Box>

//     {/* ================= WISHLIST / MATCHING / DELETE ================= */}
//     <Box sx={{ display: 'flex', gap: 0.5, px: 0.5, py: 0.5 }}>
//       <Button
//         startIcon={<FavoriteBorder sx={{ fontSize: 15 }} />}
//         variant="outlined"
//         onClick={(e) => handleWishlistClick(property.id, e)}
//         sx={{
//           flex: 1, textTransform: 'none', borderRadius: '6px',
//           borderColor: '#D9A441', color: '#D9A441', fontWeight: 600, fontSize: '0.68rem',
//           '&:hover': { borderColor: '#D9A441', backgroundColor: 'rgba(217,164,65,0.06)' },
//         }}
//       >
//         Wishlist ({property.wishlistCount})
//       </Button>

//       <Button
//         startIcon={<PeopleAlt sx={{ fontSize: 15 }} />}
//         variant="outlined"
//         onClick={(e) => handleMatchingBuyersClick(property.id, e)}
//         sx={{
//           flex: 1, textTransform: 'none', borderRadius: '6px',
//           borderColor: '#2ECC71', color: '#2ECC71', fontWeight: 600, fontSize: '0.68rem',
//           '&:hover': { borderColor: '#2ECC71', backgroundColor: 'rgba(46,204,113,0.06)' },
//         }}
//       >
//         Matching ({property.matchingBuyersCount || 0})
//       </Button>

    
//         <Button
//     startIcon={<DeleteOutline sx={{ fontSize: 15 }} />}  // ← Use Delete from @mui/icons-material
//     variant="outlined"
//     onClick={(e) => {
//       e.stopPropagation();
//       setMenuPropertyIdToDelete(property.id);
//       setShowDeleteConfirm(true);
//     }}
//     sx={{
//       flex: 1, minWidth: 0, textTransform: 'none', borderRadius: '6px',
//       borderColor: '#E74C3C', color: '#E74C3C', fontWeight: 600, fontSize: '0.68rem',
//       '&:hover': { borderColor: '#E74C3C', backgroundColor: 'rgba(231,76,60,0.06)' },
//     }}
//   >
//     Delete
//   </Button>
//     </Box>

//     {/* ================= EXTEND / VIEWS / DAYS LEFT ================= */}
//     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.5, px: 1, pb: 1, flexWrap: 'wrap' }}>
//       <Box sx={{ display: 'flex', gap: 0.8 }}>
//       <Button
//   variant="outlined"
//   disabled={property.daysLeft > 7}
//   onClick={handleExtensionClick}
//   startIcon={<AccessTimeIcon sx={{ fontSize: 16, color: '#c3790b' }} />}
//   sx={{
//     textTransform: 'none', 
//     borderRadius: '6px', 
//     fontSize: '0.7rem', 
//     fontWeight: 500,
//     backgroundColor: '#fff',
//     borderColor: '#d0d0d0',
//     color: '#c3790b',
//     px: 1, 
//     // py: 0.6, 
//     whiteSpace: 'nowrap',
//     '&:hover': {
//       backgroundColor: '#f5f5f5',
//       borderColor: '#d0d0d0',
//     },
//     '&.Mui-disabled': {
//       backgroundColor: '#fff',
//       borderColor: '#d0d0d0',
//       color: '#c3790b',
//       opacity: 0.6,
//     }
//   }}
// >
//   Extend Your Post
// </Button>

//     <Button
//   startIcon={<VisibilityIcon sx={{ fontSize: 14, color: '#000' }} />}
//   variant="outlined"
//   disableElevation
//   onClick={(e) => handleViewListClick(property.id, e)}
//   sx={{
//     textTransform: 'none', 
//     borderRadius: '6px', 
//     fontSize: '0.65rem', 
//     fontWeight: 600,
//     backgroundColor: '#fff', 
//     color: '#000',
//     border: '1px solid #cec6c6',
//     px: 1.3, 
//     py: 0.4, 
//     whiteSpace: 'nowrap',
//     '&:hover': { 
//       backgroundColor: '#f5f5f5',
//       border: '1px solid #cec6c6',
//     },
//   }}
// >
//   Views ({property.viewCount})
// </Button>
//       </Box>

//       <Typography
//         sx={{
//           fontWeight: 700, fontSize: '0.8rem', whiteSpace: 'nowrap',
//           color: property.daysLeft === null ? '#1976d2' : property.daysLeft === 0 ? '#e53935' : property.daysLeft <= 7 ? '#ff9800' : '#2e7d32',
//         }}
//       >
//         {property.daysLeft === null ? 'No Expiry' : property.daysLeft === 0 ? 'Expired' : `Days left: ${property.daysLeft}`}
//       </Typography>
//     </Box>
//   </Card>
// );

//   // Render simplified property card with checkbox (Tab 2)
//   const renderSimplifiedPropertyCard = (property) => (
//     <Card
//       key={property.id}
//       sx={{
//         mb: 1.2,
//         mx: 2,
//         borderRadius: 3,
//         boxShadow: 2,
//         position: 'relative',
//         transition: 'transform 0.2s ease-in-out',
//         '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
//       }}
//       onClick={(e) => {
//         const isInteractiveElement =
//           e.target.closest('button') ||
//           e.target.closest('svg') ||
//           e.target.closest('input[type="checkbox"]');
//         if (!isInteractiveElement) {
//           navigate('/buy-description', { state: { propertyId: property.id, property: property.propertyData } });
//         }
//       }}
//     >
//       {/* Checkbox at top right */}
//       <Box sx={{ position: 'absolute', top: 10, right: 10, zIndex: 10 }}>
//         <input
//           type="checkbox"
//           checked={selectedProperties.includes(property.id)}
//           onChange={(e) => {
//             e.stopPropagation();
//             handleCheckboxChange(property.id);
//           }}
//           style={{
//             width: 20,
//             height: 20,
//             cursor: 'pointer',
//             accentColor: '#1976d2',
//           }}
//         />
//       </Box>

//       <Box position="relative">
//         <CardMedia
//           component="img"
//           image={property.images[currentImageIndex[property.id]]}
//           alt="Property"
//           sx={{
//             width: '100%',
//             height: '140px',
//             objectFit: 'cover',
//             borderTopLeftRadius: 12,
//             borderTopRightRadius: 12,
//           }}
//         />

//         {property.images.length > 1 && (
//           <>
//             <IconButton
//               sx={{
//                 position: 'absolute',
//                 top: '50%',
//                 left: 8,
//                 opacity: 0,
//                 transform: 'translateY(-50%)',
//                 backgroundColor: 'rgba(255,255,255,0.3)',
//                 backdropFilter: 'blur(2px)',
//                 '&:hover': {
//                   opacity: 1,
//                   backgroundColor: 'rgba(255,255,255,0.5)'
//                 }
//               }}
//               onClick={(e) => handlePrevImage(property.id, e)}
//             >
//               <ChevronLeft fontSize="small" />
//             </IconButton>
//             <IconButton
//               sx={{
//                 position: 'absolute',
//                 top: '50%',
//                 right: 8,
//                 opacity: 0,
//                 transform: 'translateY(-50%)',
//                 backgroundColor: 'rgba(255,255,255,0.3)',
//                 backdropFilter: 'blur(2px)',
//                 '&:hover': {
//                   opacity: 1,
//                   backgroundColor: 'rgba(255,255,255,0.5)'
//                 }
//               }}
//               onClick={(e) => handleNextImage(property.id, e)}
//             >
//               <ChevronRight fontSize="small" />
//             </IconButton>
//           </>
//         )}

//         {property.images.length > 1 && (
//           <Box
//             sx={{
//               position: 'absolute',
//               bottom: 10,
//               left: '50%',
//               transform: 'translateX(-50%)',
//               display: 'flex',
//               gap: 1
//             }}
//           >
//             {property.images.map((_, index) => (
//               <Box
//                 key={index}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setCurrentImageIndex(prev => ({
//                     ...prev,
//                     [property.id]: index
//                   }));
//                 }}
//                 sx={{
//                   width: 8,
//                   height: 8,
//                   borderRadius: '50%',
//                   backgroundColor: currentImageIndex[property.id] == index ? '#1976d2' : '#ccc',
//                   cursor: 'pointer',
//                   transition: 'background-color 0.3s'
//                 }}
//               />
//             ))}
//           </Box>
//         )}
//       </Box>

//       <CardContent sx={{
//         px: 2, py: 0.2, pb: '7px !important',
//         borderBottom: 'none',
//         '&:last-child': {
//           paddingBottom: '7px !important',
//           borderBottom: 'none'
//         }
//       }}>
//         <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={0.5}>
//           <Typography
//             variant="subtitle1"
//             fontWeight="bold"
//             noWrap
//             sx={{
//               flex: 1,
//               overflow: 'hidden',
//               textOverflow: 'ellipsis',
//               pr: 1
//             }}
//           >
//             {property.title}-{truncateText(property.property_name, 17)}
//           </Typography>
//           <Typography variant="body2" fontWeight="bold" color="primary" noWrap>
//             ₹{Number(String(property.price).replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
//           </Typography>
//         </Box>

//         <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//           <Typography
//             variant="caption"
//             color="text.secondary"
//             noWrap
//             sx={{
//               flex: 1,
//               overflow: 'hidden',
//               textOverflow: 'ellipsis',
//               pr: 1
//             }}
//           >
//             {property.location}
//           </Typography>
//           <Typography variant="caption" color="text.secondary" noWrap>
//             {new Date(property.date).toLocaleDateString('en-IN', {
//               day: '2-digit',
//               month: '2-digit',
//               year: 'numeric'
//             })}
//           </Typography>
//         </Box>

//         <Box display="flex" alignItems="center" mt={0.2}>
//           <IconButton
//             onClick={(e) => {
//               e.stopPropagation();
//               if (property.lat && property.long) {
//                 openGoogleMapsWithDirections(property.lat, property.long);
//               }
//             }}
//           >
//             <LocationOn fontSize="small" color="action" />
//           </IconButton>

//           <Typography variant="caption" color="text.primary" ml={0.5}>
//             Location
//           </Typography>
          
//           {(() => {
//             const status = !property.admin_status || property.admin_status === '' ? 'pending' : property.admin_status.toLowerCase();
            
//             const getStyles = () => {
//               switch(status) {
//                 case 'approved': return { borderColor: '#5dc460f2', icon: <CheckCircleIcon sx={{ fontSize: 14, color: '#4caf50' }} />, label: 'approved' };
//                 case 'rejected': return { borderColor: '#f85347f2', icon: <CancelIcon sx={{ fontSize: 14, color: '#f44336' }} />, label: 'rejected' };
//                 default: return { borderColor: '#ff9800', icon: <HourglassEmptyIcon sx={{ fontSize: 14, color: '#ff9800' }} />, label: 'pending' };
//               }
//             };
            
//             const { borderColor, icon, label } = getStyles();
            
//             return (
//               <Box sx={{ mx: 2, flex: 1, display: 'flex', justifyContent: 'center' }}>
//                 <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: '4px', border: `1px solid ${borderColor}`, color: '#000000be', px: 1.5, py: 0.4, borderRadius: 0, fontSize: '0.7rem', fontWeight: 'bold', letterSpacing: '0.5px', backgroundColor: 'transparent' }}>
//                   {icon}
//                   {label}
//                 </Typography>
//               </Box>
//             );
//           })()}
          
//           <Box sx={{ flexGrow: 1 }} /> 
//           <Button
//             size="small"
//             variant="outlined"
//             color="success"
//             startIcon={<Call />}
//             sx={{ textTransform: 'none', px: 1.2, py: 0.3, fontSize: '0.7rem' }}
//             onClick={(e) => handleCallClick(e, property)}
//           >
//             Call
//           </Button>
//         </Box>

//         <Box
//           sx={{
//             display: 'flex',
//             border: '1px solid #e0e0e0',
//             borderRadius: 2,
//             overflow: 'hidden',
//           }}
//         >
//           {[
//             { label: 'Facing', value: property.facing },
//             { label: `Area `, value: property.area || property.max_acres },
//             { label: 'Posted By', value: property.posted_by },
//           ].map((item, index) => (
//             <Box
//               key={index}
//               sx={{
//                 flex: 1,
//                 px: 1,
//                 py: 0.2,
//                 textAlign: 'center',
//                 borderRight: index < 2 ? '1px solid #e0e0e0' : 'none',
//               }}
//             >
//               <Typography variant="caption" color="text.secondary" noWrap>
//                 {item.label}
//               </Typography>
//               <Typography variant="body2" fontWeight="bold" noWrap>
//                 {item.value}
//               </Typography>
//             </Box>
//           ))}
//         </Box>
//       </CardContent>
//     </Card>
//   );

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           backgroundColor: 'rgb(239, 231, 221)',
//           minHeight: '100vh',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           gap: 3,
//         }}
//       >
//         <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
//         <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
//           Loading properties...
//         </Typography>
//       </Box>
//     );
//   }

//   if (error) return <Box>Error: {error}</Box>;

//   return (
//     <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>
//       {/* Fixed Top Section */}
//       <Box
//         sx={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           zIndex: 1200,
//           backgroundColor: 'rgb(239, 231, 221)',
//           px: 1,
//           py: 1,
//           boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
//         }}
//       >
//         <CustomSearchBar
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />

//     <Box
//   sx={{
//     mt: 1,
//     px: 1,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between'
//   }}
// >
//   <Typography
//     variant="h6"
//     sx={{ fontWeight: 'bold' }}
//   >
//     My Properties
//   </Typography>

//   {filteredProperties.length > 0 && currentTab === 0 && (
//     <Button
//       variant="contained"
//       color="primary"
//       onClick={handleBoostProperty}
//       disabled={boostLoading}
//       startIcon={!boostLoading && <RocketIcon sx={{ fontSize: 18 }} />}
//       sx={{
//         fontSize: '0.75rem',
//         fontWeight: 600,
//         textTransform: 'none',
//         backgroundColor: '#6B3620',
//         color: '#FFFFFF',
//         borderRadius: '8px',
//         padding: '6px 16px',
//         '&:hover': {
//           backgroundColor: '#8A4A2E',
//         },
//         '&.Mui-disabled': {
//           backgroundColor: '#6B3620',
//           color: '#FFFFFF',
//           opacity: 0.7,
//         }
//       }}
//     >
//       {boostLoading ? (
//         <CircularProgress size={20} sx={{ color: 'white' }} />
//       ) : (
//         'Boost Your Property'
//       )}
//     </Button>
//   )}
// </Box>
//       </Box>

//       {/* Property List Section with Button-style Tabs */}
//       <Box
//         sx={{
//           pt: { xs: '90px', sm: '150px' },
//           pb: 8
//         }}
//       >
//         {/* Button-style Tabs */}
//         {/* Button-style Tabs */}
// {/* <Box sx={{ 
//   display: 'flex', 
//   gap: 1, 
//   mx: 2, 
//   mb: 2,
//   backgroundColor: '#e8e0d8',
//   borderRadius: 2,
//   padding: '4px',
// }}>
//   <Button
//     onClick={() => handleTabChange(0)}
//     sx={{
//       flex: 1,
//       backgroundColor: currentTab === 0 ? '#E0961E' : 'transparent',
//       color: currentTab === 0 ? 'white' : '#666',
//       fontWeight: currentTab === 0 ? 600 : 500,
//       fontSize: '0.75rem',
//       textTransform: 'none',
//       borderRadius: '6px',
//       padding: '6px 12px',
//       minHeight: '32px',
//       '&:hover': {
//         backgroundColor: currentTab === 0 ? '#E0961E' : '#d5cdc5',
//       },
//       transition: 'all 0.3s ease',
//     }}
//   >
//     All Properties
//   </Button>
//   <Button
//     onClick={() => handleTabChange(1)}
//     sx={{
//       flex: 1,
//       backgroundColor: currentTab === 1 ? '#E0961E' : 'transparent',
//       color: currentTab === 1 ? 'white' : '#666',
//       fontWeight: currentTab === 1 ? 600 : 500,
//       fontSize: '0.75rem',
//       textTransform: 'none',
//       borderRadius: '6px',
//       padding: '6px 12px',
//       minHeight: '32px',
//       '&:hover': {
//         backgroundColor: currentTab === 1 ? '#E0961E' : '#d5cdc5',
//       },
//       transition: 'all 0.3s ease',
//     }}
//   >
//     Selected Properties
//   </Button>
// </Box> */}

//         {/* Tab Panels */}
//         {currentTab === 0 ? (
//           // Tab 1: Full view with all buttons
//           <Box>
//             {filteredProperties.length > 0 ? (
//               filteredProperties.map((property) => renderFullPropertyCard(property))
//             ) : (
//               showNoResults && (
//                 <Box sx={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   height: '200px',
//                   px: 2
//                 }}>
//                   <Typography>
//                     {searchQuery ? 'No properties found matching your search.' : 'No properties found.'}
//                   </Typography>
//                 </Box>
//               )
//             )}
//           </Box>
//         ) : (
//           // Tab 2: Simplified view with checkboxes
//           <Box>
//             {filteredProperties.length > 0 ? (
//               filteredProperties.map((property) => renderSimplifiedPropertyCard(property))
//             ) : (
//               showNoResults && (
//                 <Box sx={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   height: '200px',
//                   px: 2
//                 }}>
//                   <Typography>
//                     {searchQuery ? 'No properties found matching your search.' : 'No properties found.'}
//                   </Typography>
//                 </Box>
//               )
//             )}
//           </Box>
//         )}
//       </Box>

//  {/* Copy Mobile Success */}
//       {showSuccess && (
//         <CopySuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowSuccess(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

// {/* Copy Mobile Failure */}
//       {showFailure && (
//         <CopyFailureAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowFailure(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

// {/* Share Success */}
//       {showShareSuccess && (
//         <ShareCopySuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowShareSuccess(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

// {/* Share Failure */}
//       {showShareFailure && (
//         <ShareCopyFailureAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowShareFailure(false);
//             setAlertMessage("");
//           }}
//         />
//       )}
// {/* Delete Success */}
//       {showDeleteSuccess && (
//         <DeleteSuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteSuccess(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

// {/* Delete Failure */}
//       {showDeleteFailure && (
//         <DeleteFailureAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteFailure(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

//       {showDeleteConfirm && (
//         <DeleteConfirmAlert
//           message={`Are you sure you want to delete property ID ${menuPropertyIdToDelete}?`}
//           onOk={() => {
//             setShowDeleteConfirm(false);
//             handleDelete();
//           }}
//           onCancel={() => setShowDeleteConfirm(false)}
//         />
//       )}

// {/* Boost Success */}
//       {showBoostSuccess && (
//         <BoostSuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowBoostSuccess(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

// {/* Boost Failure */}
//       {showBoostFailure && (
//         <BoostFailureAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowBoostFailure(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

//       <BottomNavbar />
//     </Box>
//   );
// };


// export default BuyPropertyCard;




import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Button,
  Menu,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RocketIcon from '@mui/icons-material/RocketLaunch';
import {
  FavoriteBorder,
  PeopleAlt,
  Share,
  Call,
  LocationOn,
  ChevronLeft,
  ChevronRight,
  MoreVert,
  DeleteOutline,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWork';
import StraightenOutlinedIcon from '@mui/icons-material/Straighten';
import ExploreOutlinedIcon from '@mui/icons-material/Explore';
import AddRoadOutlinedIcon from '@mui/icons-material/AddRoad';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAlt';
import TagOutlinedIcon from '@mui/icons-material/Tag';
import axios from 'axios';
import buildingImage from './../../../../Images/house.jpeg';
import CustomSearchBar from './../../Lease Module/CustomSearch';
import BottomNavbar from './../../Post Module/FormsBottomNavbar';
import { AuthContext } from './../../../AuthContext/AuthContext';
import { BASE_URL } from './../../../Api/ApiUrls';
import CopyFailureAlert from '../../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../../Alertpage/CopyAlert/CopySuccessAlert';
import ShareCopySuccessAlert from '../../Alertpage/ShareAlert/ShareCopySuccessAlert';
import ShareCopyFailureAlert from '../../Alertpage/ShareAlert/ShareCopyFailureAlert';
import DeleteFailureAlert from '../../Alertpage/DeleteAlert/DeleteFailureAlert';
import DeleteSuccessAlert from '../../Alertpage/DeleteAlert/DeleteSuccessAlert';
import DeleteConfirmAlert from '../../Alertpage/DeleteAlert/DeleteConfirmAlert';
import BoostFailureAlert from '../../Alertpage/CopyAlert/BoostFailureAlert';
import BoostSuccessAlert from '../../Alertpage/CopyAlert/BoostAlert';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
const API_BASE_URL = 'https://landnest.net:7000/api';

const BuyPropertyCard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = useContext(AuthContext);

  const [searchQuery, setSearchQuery] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [error, setError] = useState(null);
  const [menuPropertyId, setMenuPropertyId] = useState(null);
  const [properties, setProperties] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [showNoResults, setShowNoResults] = useState(false);

  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showShareSuccess, setShowShareSuccess] = useState(false);
  const [showShareFailure, setShowShareFailure] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [showDeleteFailure, setShowDeleteFailure] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [menuPropertyIdToDelete, setMenuPropertyIdToDelete] = useState(null);

  const [showBoostSuccess, setShowBoostSuccess] = useState(false);
  const [showBoostFailure, setShowBoostFailure] = useState(false);
  const [boostLoading, setBoostLoading] = useState(false);

  const [currentTab, setCurrentTab] = useState(() => {
    const path = location.pathname;
    if (path.includes('/user-buy-simplified')) return 1;
    return 0;
  });
  const [selectedProperties, setSelectedProperties] = useState([]);

  const colors = {
    primary: '#3B2314',
    gold: '#B8860B',
    goldSoft: 'rgba(184,134,11,0.10)',
    background: 'rgb(239, 231, 221)',
    cardBackground: '#FFFFFF',
    line: '#E8E5E0',
    textDark: '#1a1a1a',
    textMuted: '#8a8a8a',
    danger: '#E74C3C',
    approved: '#2E7D32',
    approvedBg: '#E8F5E9',
    pending: '#F57C00',
    pendingBg: '#FFF3E0',
    rejected: '#C62828',
    rejectedBg: '#FFEBEE',
    specBg: '#FAF8F5',
  };

  const handleTabChange = (newValue) => {
    setCurrentTab(newValue);
    if (newValue === 0) navigate('/user-buy');
    else navigate('/user-buy-simplified');
  };

  const handleCheckboxChange = (propertyId) => {
    setSelectedProperties((prev) =>
      prev.includes(propertyId) ? prev.filter((id) => id !== propertyId) : [...prev, propertyId]
    );
  };

  /* ==================== HELPERS ==================== */
  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const calculateDaysLeft = (expiredDate) => {
    if (!expiredDate) return 0;
    const now = new Date();
    const expiry = new Date(expiredDate);
    const diffTime = expiry - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

 const formatDate = (dateString) => {
  if (!dateString) return 'Not specified';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Not specified';

  const now = new Date();
  const diffMs = now - date;

  if (diffMs < 0) return 'Just now'; // future guard

  const diffSecs  = Math.floor(diffMs / 1000);
  const diffMins  = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays  = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffSecs < 60)   return 'Just now';
  if (diffMins < 60)   return `${diffMins}m ago`;
  if (diffHours < 24)  return `${diffHours}h ago`;
  if (diffDays < 7)    return `${diffDays}d ago`;
  if (diffDays < 30)   return `${Math.floor(diffDays / 7)}w ago`;

  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

 const formatDateLong = (dateString) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

  const getStatusStyles = (status) => {
    const s = (status || '').toLowerCase();
    switch (s) {
      case 'approved':
        return {
          color: colors.approved,
          bg: colors.approvedBg,
          border: colors.approved,
          icon: <CheckCircleIcon sx={{ fontSize: 13 }} />,
          label: 'Approved',
        };
      case 'rejected':
        return {
          color: colors.rejected,
          bg: colors.rejectedBg,
          border: colors.rejected,
          icon: <CancelIcon sx={{ fontSize: 13 }} />,
          label: 'Rejected',
        };
      default:
        return {
          color: colors.pending,
          bg: colors.pendingBg,
          border: colors.pending,
          icon: <HourglassEmptyIcon sx={{ fontSize: 13 }} />,
          label: 'Pending',
        };
    }
  };

  const handleCallClick = async (e, property) => {
    e.stopPropagation();
    try {
      if (property.mobile_no) {
        await navigator.clipboard.writeText(property.mobile_no);
        setAlertMessage(`Copied: ${property.mobile_no}`);
        setShowSuccess(true);
        setShowFailure(false);
      } else {
        setAlertMessage('Mobile number not available');
        setShowFailure(true);
        setShowSuccess(false);
      }
    } catch (error) {
      setAlertMessage('Failed to copy mobile number');
      setShowFailure(true);
      setShowSuccess(false);
    }
  };

  const handleShare = async (event, property) => {
    event.stopPropagation();
    const propertyUrl = `${window.location.origin}/buy-description/${property.id}`;
    try {
      await navigator.clipboard.writeText(propertyUrl);
      setAlertMessage('Property link copied successfully!');
      setShowShareSuccess(true);
      setShowShareFailure(false);
    } catch (error) {
      setAlertMessage('Failed to copy property link');
      setShowShareFailure(true);
      setShowShareSuccess(false);
    }
  };

  const handleMenuOpen = (event, propertyId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setMenuPropertyId(propertyId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuPropertyId(null);
  };

  const handleEdit = () => {
    navigate(`/user-edit-buy/${menuPropertyId}`);
  };

  const handleDelete = async () => {
    if (!menuPropertyIdToDelete) return;
    try {
      const response = await fetch(`${BASE_URL}/property/${menuPropertyIdToDelete}/`, {
        method: 'DELETE',
      });
      if (response.ok) {
        setProperties((prev) => prev.filter((p) => p.id !== menuPropertyIdToDelete));
        setAlertMessage(`Property ID ${menuPropertyIdToDelete} deleted successfully.`);
        setShowDeleteSuccess(true);
      } else {
        const errorData = await response.json();
        setAlertMessage(
          `Failed to delete property ID ${menuPropertyIdToDelete}. Reason: ${
            errorData.detail || 'Unknown error'
          }`
        );
        setShowDeleteFailure(true);
      }
    } catch (error) {
      console.error('Error deleting property:', error);
      setAlertMessage('An error occurred while trying to delete the property.');
      setShowDeleteFailure(true);
    } finally {
      setMenuPropertyIdToDelete(null);
      handleMenuClose();
    }
  };

  const isBudgetInRange = (propertyPrice, minBudget, maxBudget) => {
    if (!propertyPrice) return false;
    if (minBudget && maxBudget) {
      const range = (maxBudget - minBudget) * 0.1;
      const extendedMin = Math.max(0, minBudget - range);
      const extendedMax = maxBudget + range;
      return propertyPrice >= extendedMin && propertyPrice <= extendedMax;
    }
    if (minBudget && !maxBudget) {
      const extendedMin = minBudget * 0.9;
      return propertyPrice >= extendedMin;
    }
    if (!minBudget && maxBudget) {
      const extendedMax = maxBudget * 1.1;
      return propertyPrice <= extendedMax;
    }
    return false;
  };

  const getPropertyImages = async (propertyId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/properties/${propertyId}/images`);
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Failed to fetch images');
      return data;
    } catch (error) {
      console.error('API Error fetching images:', error);
      return { success: false, images: [] };
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      setShowNoResults(false);

      const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
      setCategories(categoriesResponse.data);

      const propertiesResponse = await axios.get(
        `${API_BASE_URL}/api/properties/user/${userId}?type=sell`
      );

      const plansResponse = await axios.get(`${BASE_URL}/Get-all-plan/${userId}/`);
      const subscriptions = plansResponse.data || [];

      const cartResponse = await axios.get(`${BASE_URL}/user-cart/`);
      const cartItems = cartResponse.data;

      const enquiriesResponse = await axios.get(`${BASE_URL}/Enquiry/`);
      const enquiries = enquiriesResponse.data;

      const activitiesResponse = await axios.get(`${BASE_URL}/activities/`);
      const activities = activitiesResponse.data.data;

      const userProperties = propertiesResponse.data.data || propertiesResponse.data;

      const sortedProperties = userProperties.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      const parsed = await Promise.all(
        sortedProperties.map(async (item) => {
          const wishlistUsers = cartItems
            .filter(
              (cartItem) =>
                cartItem.property_id === item.property_id && cartItem.user_id !== userId
            )
            .map((cartItem) => cartItem.user_id);

          const uniqueWishlistUsers = [...new Set(wishlistUsers)];
          const wishlistCount = uniqueWishlistUsers.length;

          const postedBy = item.posted_by?.replace(/"/g, '') || '';
          const requiredUserType = mapPostedByToUserType(postedBy);

          const matchedSub = subscriptions.find(
            (sub) => sub.status === true && sub.user_type === requiredUserType
          );

          const daysLeftForProperty = matchedSub?.expired_date
            ? calculateDaysLeft(matchedSub.expired_date)
            : null;

          const viewCount = [
            ...new Set(
              activities
                .filter(
                  (activity) =>
                    activity.property_id === item.property_id &&
                    activity.activity_type === 'Description' &&
                    activity.user_id !== userId
                )
                .map((activity) => activity.user_id)
            ),
          ].length;

          const matchingBuyersCount = enquiries.filter((enquiry) => {
            const propertyCategory = categoriesResponse.data.find(
              (cat) => cat.category_id == item.category_id_id
            )?.category;

            const typeMatch =
              enquiry.property_type &&
              propertyCategory &&
              enquiry.property_type.toLowerCase() === propertyCategory.toLowerCase();

            const budgetMatch = isBudgetInRange(item.price, enquiry.min_budget, enquiry.max_budget);

            const locationMatch = () => {
              if (!enquiry.lat || !enquiry.long || !item.lat || !item.long) return false;
              const propLat = parseFloat(item.lat);
              const propLong = parseFloat(item.long);
              const enqLat = parseFloat(enquiry.lat);
              const enqLong = parseFloat(enquiry.long);
              const R = 6371;
              const dLat = ((enqLat - propLat) * Math.PI) / 180;
              const dLon = ((enqLong - propLong) * Math.PI) / 180;
              const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos((propLat * Math.PI) / 180) *
                  Math.cos((enqLat * Math.PI) / 180) *
                  Math.sin(dLon / 2) *
                  Math.sin(dLon / 2);
              const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
              const distance = R * c;
              return distance <= 10;
            };

            return typeMatch && budgetMatch && locationMatch();
          }).length;

          const parseCoord = (coord) => {
            if (!coord) return null;
            const cleaned = String(coord).replace(/"/g, '').replace(':', '.');
            return parseFloat(cleaned);
          };

          const matchedCategory = categoriesResponse.data.find(
            (cat) => cat.category_id == item.category_id_id
          );
          const categoryName = matchedCategory ? matchedCategory.category : 'Property';

          let images = [buildingImage];
          try {
            const imageResponse = await getPropertyImages(item.property_id);
            if (
              imageResponse.success &&
              imageResponse.images &&
              imageResponse.images.length > 0
            ) {
              images = imageResponse.images.map((img) => {
                if (img.startsWith('http')) return img;
                if (img.startsWith('/')) return `${BASE_URL}${img}`;
                return `${BASE_URL}/${img}`;
              });
            }
          } catch (imgError) {
            console.error(`Error fetching images for property ${item.property_id}:`, imgError);
          }

          return {
            id: item.property_id,
            title: categoryName,
            location: item.location || 'Not specified',
            price: item.price,
            formattedPrice: `₹${Math.round(item.price).toLocaleString('en-IN')}`,
            date: item.created_at,
            facing: item.facing?.replace(/"/g, '') || 'N/A',
            area: item.site_area
              ? `${item.site_area} ${
                  ['ft', 'm', 'cm', 'in', 'Sq.Yd'].includes(item.units)
                    ? `Sq ${item.units}`
                    : item.units || 'Sq ft'
                }`
              : 'N/A',
            max_acres: item.max_acres ? `${item.max_acres} ${item.units || 'acres'}` : 'N/A',
            dimensions: item.roadwidth ? `${Math.round(item.roadwidth)} ft road` : 'N/A',
            posted_by: item.posted_by?.replace(/"/g, '') || 'Agent',
            lat: parseCoord(item.lat),
            long: parseCoord(item.long),
            length: item.length,
            width: item.width,
            mobile_no: item.mobile_no,
            property_name: item.property_name,
            images: images,
            propertyData: item,
            wishlistCount: wishlistCount,
            viewCount: viewCount,
            matchingBuyersCount: matchingBuyersCount,
            daysLeft: daysLeftForProperty,
            admin_status: item.Admin_status || '',
          };
        })
      );

      setProperties(parsed);

      const initialIndexes = {};
      parsed.forEach((property) => {
        initialIndexes[property.id] = 0;
      });
      setCurrentImageIndex(initialIndexes);

      if (parsed.length === 0) setShowNoResults(true);
    } catch (error) {
      console.error('Error fetching data:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [userId]);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/user-buy-simplified')) setCurrentTab(1);
    else if (path.includes('/user-buy')) setCurrentTab(0);
  }, [location.pathname]);

  const handleWishlistClick = (propertyId, e) => {
    e.stopPropagation();
    navigate(`/wishlist-users/${propertyId}`);
  };

  const handleMatchingBuyersClick = (propertyId, e) => {
    e.stopPropagation();
    navigate(`/matching-buyers/${propertyId}`);
  };

  const handleNextImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => {
      const currentIndex = prev[propertyId];
      const property = properties.find((p) => p.id == propertyId);
      const nextIndex = (currentIndex + 1) % property.images.length;
      return { ...prev, [propertyId]: nextIndex };
    });
  };

  const handlePrevImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => {
      const currentIndex = prev[propertyId];
      const property = properties.find((p) => p.id == propertyId);
      const prevIndex =
        (currentIndex - 1 + property.images.length) % property.images.length;
      return { ...prev, [propertyId]: prevIndex };
    });
  };

  const openGoogleMapsWithDirections = (destLat, destLng) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const currentLat = position.coords.latitude;
          const currentLng = position.coords.longitude;
          const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${destLat},${destLng}&travelmode=driving`;
          window.open(googleMapsUrl, '_blank');
        },
        (error) => {
          console.error('Error getting location:', error);
          alert('Could not get your location. Please allow location access.');
        }
      );
    } else {
      alert('Geolocation is not supported by your browser.');
    }
  };

  const filteredProperties = properties.filter(
    (property) =>
      property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      property.location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const mapPostedByToUserType = (postedBy) => {
    if (!postedBy) return null;
    const value = postedBy.toLowerCase();
    if (value === 'owner' || value === 'builder') return 'Individual Owner/Builder';
    if (value === 'agent') return 'Agent';
    return null;
  };

  const handleBoostProperty = async () => {
    setBoostLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/boost-property/`, { user_id: userId });
      console.log('Boost success:', response.data);
      setAlertMessage('Property boosted successfully!');
      setShowBoostSuccess(true);
    } catch (error) {
      console.error('Boost failed:', error);
      setAlertMessage('Failed to boost property. Please try again.');
      setShowBoostFailure(true);
    } finally {
      setBoostLoading(false);
    }
  };

  const handleExtensionClick = (e) => {
    e.stopPropagation();
    navigate('/user-subscription');
  };

  const handleViewListClick = (propertyId, e) => {
    e.stopPropagation();
    navigate(`/viewlistpage/${propertyId}`);
  };

  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: colors.background,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
        <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
          Loading properties...
        </Typography>
      </Box>
    );
  }

  if (error) return <Box>Error: {error}</Box>;

  /* ==================== SPEC CELL ==================== */
  const SpecCell = ({ icon, label, value, index, total }) => (
    <Box
      sx={{
        px: 1.2,
        py: 1,
        position: 'relative',
        minWidth: 0,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 0.8,
        ...(index % 2 === 0 &&
          index !== total - 1 && {
            '&::after': {
              content: '""',
              position: 'absolute',
              right: 0,
              top: '18%',
              height: '64%',
              width: '1px',
              backgroundColor: colors.line,
            },
          }),
        ...(index < total - (total % 2 === 0 ? 2 : 1) && {
          borderBottom: `1px solid ${colors.line}`,
        }),
      }}
    >
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: '6px',
          backgroundColor: '#F3EFE8',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          mt: 0.2,
          color: '#8a7a5c',
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: '0.6rem',
            color: colors.textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            fontWeight: 600,
            mb: 0.2,
            lineHeight: 1.1,
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: '0.78rem',
            fontWeight: 700,
            color: colors.textDark,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {value || 'Not specified'}
        </Typography>
      </Box>
    </Box>
  );

  // ══════════════════════════════════════════════════════════════════════════
  // FULL PROPERTY CARD — UNIFIED UI (matches JV/JD, Rent, Lease, Bank Auction)
  // ══════════════════════════════════════════════════════════════════════════
  const renderFullPropertyCard = (property) => {
    const status = getStatusStyles(property.admin_status);
    const daysLeft = property.daysLeft;

    const specs = [
      {
        label: 'Property Type',
        value: property.title,
        icon: <HomeWorkOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: 'Area',
        value: property.area || property.max_acres,
        icon: <StraightenOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: 'Facing',
        value: property.facing,
        icon: <ExploreOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: 'Posted By',
        value: property.posted_by,
        icon: <PeopleAltOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: 'Dimensions',
        value: property.dimensions,
        icon: <AddRoadOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: 'Property ID',
        value: property.id ? `#${property.id}` : null,
        icon: <TagOutlinedIcon sx={{ fontSize: 15 }} />,
      },
    ];

    return (
      <Card
        key={property.id}
        onClick={(e) => {
          const isInteractiveElement =
            e.target.closest('button') ||
            e.target.closest('svg') ||
            e.target.closest('.MuiMenu-root') ||
            e.target.closest('.MuiMenuItem-root');
          if (!isInteractiveElement) {
            navigate('/buy-description', {
              state: { propertyId: property.id, property: property.propertyData },
            });
          }
        }}
        sx={{
          mb: 1.5,
          mx: 1,
          borderRadius: '14px',
          backgroundColor: colors.cardBackground,
          border: `1px solid ${colors.line}`,
          boxShadow: '0 2px 10px rgba(0,0,0,0.07)',
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            boxShadow: '0 6px 18px rgba(0,0,0,0.13)',
            transform: 'translateY(-2px)',
          },
        }}
      >
        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
          {/* ============ TOP ROW: IMAGE (LEFT) + DETAILS (RIGHT) ============ */}
          <Box
            sx={{
              display: 'flex',
              gap: 1.2,
              p: 1.2,
              height: 210,
              boxSizing: 'border-box',
            }}
          >
            {/* ── Image column ── */}
            <Box
              sx={{
                position: 'relative',
                width: '42%',
                height: '100%',
                flexShrink: 0,
                borderRadius: '10px',
                overflow: 'hidden',
                backgroundColor: '#F5F5F5',
              }}
            >
              <CardMedia
                component="img"
                image={property.images[currentImageIndex[property.id]]}
                alt="Property"
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />

              {/* Share / More icons top-right */}
              <Box sx={{ position: 'absolute', top: 6, right: 6, display: 'flex', gap: 0.5 }}>
                <IconButton
                  size="small"
                  sx={{
                    bgcolor: 'rgba(255,255,255,0.9)',
                    width: 26,
                    height: 26,
                    '&:hover': { bgcolor: '#fff' },
                  }}
                  onClick={(e) => handleShare(e, property)}
                >
                  <Share sx={{ fontSize: 14 }} />
                </IconButton>
                <IconButton
                  size="small"
                  sx={{
                    bgcolor: 'rgba(255,255,255,0.9)',
                    width: 26,
                    height: 26,
                    '&:hover': { bgcolor: '#fff' },
                  }}
                  onClick={(e) => handleMenuOpen(e, property.id)}
                >
                  <MoreVert sx={{ fontSize: 14 }} />
                </IconButton>
              </Box>

              {/* Photo count bottom-left */}
              {property.images.length > 0 && (
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 8,
                    left: 8,
                    backgroundColor: 'rgba(0,0,0,0.65)',
                    color: '#FFFFFF',
                    fontSize: '0.6rem',
                    fontWeight: 600,
                    px: 0.8,
                    py: 0.3,
                    borderRadius: '5px',
                    lineHeight: 1.1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.3,
                  }}
                >
                  <CollectionsOutlinedIcon sx={{ fontSize: 11 }} />
                  {currentImageIndex[property.id] + 1} / {property.images.length}
                </Box>
              )}

              {/* Carousel arrows */}
              {property.images.length > 1 && (
                <>
                  <IconButton
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: 4,
                      opacity: 0,
                      transform: 'translateY(-50%)',
                      backgroundColor: 'rgba(255,255,255,0.5)',
                      backdropFilter: 'blur(2px)',
                      transition: 'opacity 0.2s',
                      '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.8)' },
                    }}
                    onClick={(e) => handlePrevImage(property.id, e)}
                  >
                    <ChevronLeft fontSize="small" />
                  </IconButton>
                  <IconButton
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      right: 4,
                      opacity: 0,
                      transform: 'translateY(-50%)',
                      backgroundColor: 'rgba(255,255,255,0.5)',
                      backdropFilter: 'blur(2px)',
                      transition: 'opacity 0.2s',
                      '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.8)' },
                    }}
                    onClick={(e) => handleNextImage(property.id, e)}
                  >
                    <ChevronRight fontSize="small" />
                  </IconButton>
                </>
              )}

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClick={(e) => e.stopPropagation()}
              >
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit();
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenuPropertyIdToDelete(property.id);
                    setShowDeleteConfirm(true);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>

            {/* ── Details column ── */}
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                gap: 0.6,
              }}
            >
              {/* status + posted time */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 0.6,
                  flexWrap: 'wrap',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.4,
                    px: 0.8,
                    py: 0.25,
                    borderRadius: '6px',
                    border: `1px solid ${status.border}`,
                    backgroundColor: status.bg,
                    color: status.color,
                  }}
                >
                  {status.icon}
                  <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, lineHeight: 1.1 }}>
                    {status.label}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                  <AccessTimeIcon sx={{ fontSize: 11, color: colors.textMuted }} />
                  <Typography sx={{ fontSize: '0.62rem', color: colors.textMuted }}>
                    {formatDate(property.date)}
                  </Typography>
                </Box>
              </Box>

              {/* title */}
              <Typography
                sx={{
                  fontSize: '0.92rem',
                  fontWeight: 800,
                  color: colors.textDark,
                  lineHeight: 1.25,
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
              >
                {property.title}-{truncateText(property.property_name, 17)}
              </Typography>

              {/* location */}
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.4 }}>
                <LocationOn
                  sx={{ fontSize: 13, color: colors.textMuted, mt: '1px', flexShrink: 0 }}
                />
                <Typography
                  sx={{
                    fontSize: '0.68rem',
                    color: '#666',
                    lineHeight: 1.3,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {property.location}
                </Typography>
              </Box>

              {/* date */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                <CalendarTodayOutlinedIcon sx={{ fontSize: 12, color: colors.textMuted }} />
                <Typography sx={{ fontSize: '0.66rem', color: '#666' }}>
                  {formatDateLong(property.date)}
                </Typography>
              </Box>

              {/* days left */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                <AccessTimeIcon sx={{ fontSize: 12, color: colors.textMuted }} />
                <Typography
                  sx={{
                    fontSize: '0.72rem',
                    fontWeight: 700,
                    color:
                      daysLeft === null
                        ? '#1976d2'
                        : daysLeft === 0
                        ? '#e53935'
                        : daysLeft <= 7
                        ? '#ff9800'
                        : '#2e7d32',
                  }}
                >
                  {daysLeft === null
                    ? 'No Expiry'
                    : daysLeft === 0
                    ? 'Expired'
                    : `${daysLeft} days left`}
                </Typography>
              </Box>

              {/* price band */}
              <Box
                sx={{
                  mt: 0.4,
                  px: 1,
                  py: 0.7,
                  borderRadius: '8px',
                  backgroundColor: colors.goldSoft,
                  border: `1px dashed ${colors.gold}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: '0.58rem',
                    fontWeight: 700,
                    color: '#8a6a1f',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    lineHeight: 1.1,
                  }}
                >
                  Price
                </Typography>
                <Typography
                  sx={{
                    fontSize: '0.85rem',
                    fontWeight: 800,
                    color: colors.gold,
                    whiteSpace: 'nowrap',
                  }}
                >
                  ₹{Number(String(property.price).replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* ============ SPEC GRID (2 columns) ============ */}
          <Box
            sx={{
              mx: 1.2,
              mb: 1,
              border: `1px solid ${colors.line}`,
              borderRadius: '10px',
              overflow: 'hidden',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              backgroundColor: colors.specBg,
            }}
          >
            {specs.map((spec, index) => (
              <SpecCell
                key={spec.label}
                icon={spec.icon}
                label={spec.label}
                value={spec.value}
                index={index}
                total={specs.length}
              />
            ))}
          </Box>

     {/* ============ FOOTER: EXTEND + VIEW + WISHLIST + MATCHING + CALL + EDIT + DELETE ============ */}
<Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 0.8,
    px: 1.2,
    py: 1,
    borderTop: `1px solid ${colors.line}`,
    backgroundColor: '#FAF8F5',
    flexWrap: 'wrap',
  }}
>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
    {/* Extend Your Post */}
    <Button
      variant="outlined"
      disabled={daysLeft !== null && daysLeft > 7}
      onClick={handleExtensionClick}
      startIcon={<AccessTimeIcon sx={{ fontSize: 15, color: '#c3790b' }} />}
      sx={{
        textTransform: 'none',
        borderRadius: '7px',
        fontSize: '0.66rem',
        fontWeight: 600,
        backgroundColor: '#fff',
        borderColor: '#d0d0d0',
        color: '#c3790b',
        px: 1,
        py: 0.4,
        whiteSpace: 'nowrap',
        minWidth: 0,
        '&:hover': { backgroundColor: '#f5f5f5', borderColor: '#d0d0d0' },
        '&.Mui-disabled': {
          backgroundColor: '#fff',
          borderColor: '#d0d0d0',
          color: '#c3790b',
          opacity: 0.6,
        },
      }}
    >
      Extend Your Post
    </Button>

    {/* View */}
    <Box
      onClick={(e) => handleViewListClick(property.id, e)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.4,
        px: 1,
        py: 0.5,
        borderRadius: '7px',
        border: `1px solid ${colors.line}`,
        backgroundColor: '#fff',
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#F5F0E8' },
      }}
    >
      <VisibilityIcon sx={{ fontSize: 13, color: '#5a5a5a' }} />
      <Typography sx={{ fontSize: '0.66rem', fontWeight: 600, color: '#5a5a5a' }}>
        View ({property.viewCount || 0})
      </Typography>
    </Box>

    {/* Wishlist */}
    <Box
      onClick={(e) => handleWishlistClick(property.id, e)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.4,
        px: 1,
        py: 0.5,
        borderRadius: '7px',
        border: `1px solid ${colors.line}`,
        backgroundColor: '#fff',
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#F5F0E8' },
      }}
    >
      <FavoriteBorder sx={{ fontSize: 13, color: '#5a5a5a' }} />
      <Typography sx={{ fontSize: '0.66rem', fontWeight: 600, color: '#5a5a5a' }}>
        Wishlist ({property.wishlistCount})
      </Typography>
    </Box>

    {/* Matching */}
    {/* <Box
      onClick={(e) => handleMatchingBuyersClick(property.id, e)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.4,
        px: 1,
        py: 0.5,
        borderRadius: '7px',
        border: `1px solid ${colors.line}`,
        backgroundColor: '#fff',
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#F5F0E8' },
      }}
    >
      <PeopleAlt sx={{ fontSize: 13, color: '#5a5a5a' }} />
      <Typography sx={{ fontSize: '0.66rem', fontWeight: 600, color: '#5a5a5a' }}>
        Matching ({property.matchingBuyersCount || 0})
      </Typography>
    </Box> */}

    {/* Call */}
    <Box
      onClick={(e) => handleCallClick(e, property)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.4,
        px: 1,
        py: 0.5,
        borderRadius: '7px',
        border: `1px solid ${colors.line}`,
        backgroundColor: '#fff',
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#F5F0E8' },
      }}
    >
      <Call sx={{ fontSize: 13, color: '#5a5a5a' }} />
      <Typography sx={{ fontSize: '0.66rem', fontWeight: 600, color: '#5a5a5a' }}>
        Call
      </Typography>
    </Box>
  </Box>

  {/* ── EDIT + DELETE at the very end ── */}
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 'auto' }}>
    {/* Edit */}
    <Button
      variant="outlined"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/user-edit-buy/${property.id}`);
      }}
      startIcon={<EditOutlinedIcon sx={{ fontSize: 14 }} />}
      sx={{
        textTransform: 'none',
        borderRadius: '7px',
        fontSize: '0.66rem',
        fontWeight: 600,
        backgroundColor: '#fff',
        borderColor: 'rgba(184,134,11,0.5)',
        color: colors.gold,
        px: 1,
        py: 0.4,
        whiteSpace: 'nowrap',
        minWidth: 0,
        '&:hover': {
          backgroundColor: 'rgba(184,134,11,0.08)',
          borderColor: colors.gold,
        },
      }}
    >
      Edit
    </Button>

    {/* Delete */}
    <Button
      variant="outlined"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        setMenuPropertyIdToDelete(property.id);
        setShowDeleteConfirm(true);
      }}
      startIcon={<DeleteOutline sx={{ fontSize: 14 }} />}
      sx={{
        textTransform: 'none',
        borderRadius: '7px',
        fontSize: '0.66rem',
        fontWeight: 600,
        backgroundColor: '#fff',
        borderColor: 'rgba(231,76,60,0.5)',
        color: colors.danger,
        px: 1,
        py: 0.4,
        whiteSpace: 'nowrap',
        minWidth: 0,
        '&:hover': {
          backgroundColor: 'rgba(231,76,60,0.08)',
          borderColor: colors.danger,
        },
      }}
    >
      Delete
    </Button>
  </Box>
</Box>
        </CardContent>
      </Card>
    );
  };

  // ══════════════════════════════════════════════════════════════════════════
  // SIMPLIFIED CARD — unchanged (its own 2-column grid layout)
  // ══════════════════════════════════════════════════════════════════════════
  const renderSimplifiedPropertyCard = (property) => (
    <Card
      key={property.id}
      sx={{
        mb: 1.2,
        mx: 2,
        borderRadius: 3,
        boxShadow: 2,
        position: 'relative',
        overflow: 'hidden',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
      }}
      onClick={(e) => {
        const isInteractiveElement =
          e.target.closest('button') ||
          e.target.closest('svg') ||
          e.target.closest('input[type="checkbox"]');
        if (!isInteractiveElement) {
          navigate('/buy-description', {
            state: { propertyId: property.id, property: property.propertyData },
          });
        }
      }}
    >
      <Box sx={{ position: 'absolute', top: 10, right: 10, zIndex: 10 }}>
        <input
          type="checkbox"
          checked={selectedProperties.includes(property.id)}
          onChange={(e) => {
            e.stopPropagation();
            handleCheckboxChange(property.id);
          }}
          style={{ width: 20, height: 20, cursor: 'pointer', accentColor: '#1976d2' }}
        />
      </Box>

      <Box position="relative" sx={{ height: 180 }}>
        <CardMedia
          component="img"
          image={property.images[currentImageIndex[property.id]]}
          alt="Property"
          sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />

        {property.images.length > 1 && (
          <>
            <IconButton
              sx={{
                position: 'absolute',
                top: '50%',
                left: 8,
                opacity: 0,
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(255,255,255,0.5)',
                backdropFilter: 'blur(2px)',
                transition: 'opacity 0.2s',
                '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.8)' },
              }}
              onClick={(e) => handlePrevImage(property.id, e)}
            >
              <ChevronLeft fontSize="small" />
            </IconButton>
            <IconButton
              sx={{
                position: 'absolute',
                top: '50%',
                right: 8,
                opacity: 0,
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(255,255,255,0.5)',
                backdropFilter: 'blur(2px)',
                transition: 'opacity 0.2s',
                '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.8)' },
              }}
              onClick={(e) => handleNextImage(property.id, e)}
            >
              <ChevronRight fontSize="small" />
            </IconButton>
          </>
        )}

        {property.images.length > 1 && (
          <Box
            sx={{
              position: 'absolute',
              bottom: 10,
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: 1,
            }}
          >
            {property.images.map((_, index) => (
              <Box
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentImageIndex((prev) => ({ ...prev, [property.id]: index }));
                }}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor:
                    currentImageIndex[property.id] == index ? '#1976d2' : '#ccc',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s',
                }}
              />
            ))}
          </Box>
        )}
      </Box>

      <CardContent
        sx={{
          px: 2,
          py: 0.2,
          pb: '7px !important',
          borderBottom: 'none',
          '&:last-child': { paddingBottom: '7px !important', borderBottom: 'none' },
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={0.5}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            noWrap
            sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', pr: 1 }}
          >
            {property.title}-{truncateText(property.property_name, 17)}
          </Typography>
          <Typography variant="body2" fontWeight="bold" color="primary" noWrap>
            ₹{Number(String(property.price).replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
          </Typography>
        </Box>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', pr: 1 }}
          >
            {property.location}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {new Date(property.date).toLocaleDateString('en-IN', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })}
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" mt={0.2}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              if (property.lat && property.long) {
                openGoogleMapsWithDirections(property.lat, property.long);
              }
            }}
          >
            <LocationOn fontSize="small" color="action" />
          </IconButton>

          <Typography variant="caption" color="text.primary" ml={0.5}>
            Location
          </Typography>

          {(() => {
            const status =
              !property.admin_status || property.admin_status === ''
                ? 'pending'
                : property.admin_status.toLowerCase();
            const getStyles = () => {
              switch (status) {
                case 'approved':
                  return {
                    borderColor: '#5dc460f2',
                    icon: <CheckCircleIcon sx={{ fontSize: 14, color: '#4caf50' }} />,
                    label: 'approved',
                  };
                case 'rejected':
                  return {
                    borderColor: '#f85347f2',
                    icon: <CancelIcon sx={{ fontSize: 14, color: '#f44336' }} />,
                    label: 'rejected',
                  };
                default:
                  return {
                    borderColor: '#ff9800',
                    icon: <HourglassEmptyIcon sx={{ fontSize: 14, color: '#ff9800' }} />,
                    label: 'pending',
                  };
              }
            };
            const { borderColor, icon, label } = getStyles();
            return (
              <Box sx={{ mx: 2, flex: 1, display: 'flex', justifyContent: 'center' }}>
                <Typography
                  variant="caption"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    border: `1px solid ${borderColor}`,
                    color: '#000000be',
                    px: 1.5,
                    py: 0.4,
                    borderRadius: 0,
                    fontSize: '0.7rem',
                    fontWeight: 'bold',
                    letterSpacing: '0.5px',
                    backgroundColor: 'transparent',
                  }}
                >
                  {icon}
                  {label}
                </Typography>
              </Box>
            );
          })()}

          <Box sx={{ flexGrow: 1 }} />
          {/* <Button
            size="small"
            variant="outlined"
            color="success"
            startIcon={<Call />}
            sx={{ textTransform: 'none', px: 1.2, py: 0.3, fontSize: '0.7rem' }}
            onClick={(e) => handleCallClick(e, property)}
          >
            Call
          </Button> */}
        </Box>

        <Box
          sx={{
            display: 'flex',
            border: '1px solid #e0e0e0',
            borderRadius: 2,
            overflow: 'hidden',
            mt: 0.5,
          }}
        >
          {[
            { label: 'Facing', value: property.facing },
            { label: `Area `, value: property.area || property.max_acres },
            { label: 'Posted By', value: property.posted_by },
          ].map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: 1,
                px: 1,
                py: 0.4,
                textAlign: 'center',
                borderRight: index < 2 ? '1px solid #e0e0e0' : 'none',
              }}
            >
              <Typography variant="caption" color="text.secondary" noWrap>
                {item.label}
              </Typography>
              <Typography variant="body2" fontWeight="bold" noWrap>
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ backgroundColor: colors.background, minHeight: '120vh' }}>
      {/* Fixed Top Section */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          backgroundColor: colors.background,
          px: 1,
          py: 1,
          boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
        }}
      >
        <CustomSearchBar value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />

        <Box
          sx={{
            mt: 1,
            px: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            My Properties
          </Typography>

          {filteredProperties.length > 0 && currentTab === 0 && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleBoostProperty}
              disabled={boostLoading}
              startIcon={!boostLoading && <RocketIcon sx={{ fontSize: 18 }} />}
              sx={{
                fontSize: '0.75rem',
                fontWeight: 600,
                textTransform: 'none',
                backgroundColor: '#6B3620',
                color: '#FFFFFF',
                borderRadius: '8px',
                padding: '6px 16px',
                '&:hover': { backgroundColor: '#8A4A2E' },
                '&.Mui-disabled': {
                  backgroundColor: '#6B3620',
                  color: '#FFFFFF',
                  opacity: 0.7,
                },
              }}
            >
              {boostLoading ? (
                <CircularProgress size={20} sx={{ color: 'white' }} />
              ) : (
                'Boost Your Property'
              )}
            </Button>
          )}
        </Box>
      </Box>

      {/* Property List Section */}
      <Box sx={{ pt: { xs: '90px', sm: '150px' }, pb: 8 }}>
        {currentTab === 0 ? (
          <Box>
            {filteredProperties.length > 0 ? (
              filteredProperties.map((property) => renderFullPropertyCard(property))
            ) : (
              showNoResults && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '200px',
                    px: 2,
                  }}
                >
                  <Typography>
                    {searchQuery
                      ? 'No properties found matching your search.'
                      : 'No properties found.'}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        ) : (
          <Box>
            {filteredProperties.length > 0 ? (
              filteredProperties.map((property) => renderSimplifiedPropertyCard(property))
            ) : (
              showNoResults && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '200px',
                    px: 2,
                  }}
                >
                  <Typography>
                    {searchQuery
                      ? 'No properties found matching your search.'
                      : 'No properties found.'}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        )}
      </Box>

      {/* Alerts */}
      {showSuccess && (
        <CopySuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
            setAlertMessage('');
          }}
        />
      )}
      {showFailure && (
        <CopyFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowFailure(false);
            setAlertMessage('');
          }}
        />
      )}
      {showShareSuccess && (
        <ShareCopySuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowShareSuccess(false);
            setAlertMessage('');
          }}
        />
      )}
      {showShareFailure && (
        <ShareCopyFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowShareFailure(false);
            setAlertMessage('');
          }}
        />
      )}
      {showDeleteSuccess && (
        <DeleteSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteSuccess(false);
            setAlertMessage('');
          }}
        />
      )}
      {showDeleteFailure && (
        <DeleteFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteFailure(false);
            setAlertMessage('');
          }}
        />
      )}
      {showDeleteConfirm && (
        <DeleteConfirmAlert
          message={`Are you sure you want to delete property ID ${menuPropertyIdToDelete}?`}
          onOk={() => {
            setShowDeleteConfirm(false);
            handleDelete();
          }}
          onCancel={() => setShowDeleteConfirm(false)}
        />
      )}
      {showBoostSuccess && (
        <BoostSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowBoostSuccess(false);
            setAlertMessage('');
          }}
        />
      )}
      {showBoostFailure && (
        <BoostFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowBoostFailure(false);
            setAlertMessage('');
          }}
        />
      )}

      <BottomNavbar />
    </Box>
  );
};

export default BuyPropertyCard;